import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MaterialService } from '../../services/material.service';
import { Observable } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { LearnerService } from 'src/app/services/learner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatSnackBar, MatAccordion } from '@angular/material';
import { CreateFolderModalComponent } from 'src/app/folder/create-folder-modal/create-folder-modal.component';
import { AddMaterialModalComponent } from 'src/app/courses/materials/add-material-modal/add-material-modal.component';
import { DeleteConfirmModalComponent } from '../delete-confirm-modal/delete-confirm-modal.component';
import * as _ from 'lodash';
import { SharedService } from 'src/app/shared.service';
import * as moment from 'moment';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { AddSessionModalComponent } from 'src/app/portfolio/add-session-modal/add-session-modal.component';
import { QuizService } from 'src/app/services/quiz.service';
import { AddQuizModalComponent } from 'src/app/quiz/add-quiz-modal/add-quiz-modal.component';
import { TimeSheetService } from '../../services/time-sheet.service';
declare var $: any;
@Component({
  selector: 'material-tile',
  templateUrl: './material-tile.component.html',
  styleUrls: ['./material-tile.component.scss']
})
export class MaterialTileComponent implements OnInit {

  @ViewChild(MatAccordion, { static: true }) accordion: MatAccordion;
  // @ViewChild(MatExpansionPanel, { static: true }) matExpansionPanelElement: MatExpansionPanel;

  @Input('material') material: any;
  @Input('isSelected') isSelected: Boolean;
  @Input('index') i: any;
  @Input('indexOf') index: any;
  @Input('jobId') jobId;
  @Input('folder') folder: any;
  @Input('learnersAllotedFromJob') learnersAlloted;
  @Input('learnersFromJob') learnersFromJob;
  @Input('allLearnersFromJob') allLearners;
  @Input('showLearnerTab') showLearnerTab;
  @Input('learnerFromSingleUnit') learnerFromSingleUnit;
  @Input('learnerWithStatus') learnerWithStatus;
  @Input('allocated') allocated;
  @Input('course') course;
  @Input('selectedUnitData') unitSelected
  @Input('singleJob') jobData
  @Input('quizStatus') learnerQuizStatus
  @Input('selectedCourse') courseSelected
  @Input('userRole') userRole
  @Input('isIQA') Iqa
  @Input('systemDate') today
  @Output() DeleteMaterial: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditMaterial: EventEmitter<any> = new EventEmitter<any>();
  @Output() getFiles: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileDetailsComp: EventEmitter<any> = new EventEmitter<any>();
  @Output() assignmentAllocated: EventEmitter<any> = new EventEmitter<any>();
  noRedirect = true
  singleJobData
  backupMaterial: any;
  isActive: string;
  editing: boolean;
  loading: boolean;
  backupmaterial: any;
  bgColors;
  tempParmas
  lastColor;
  allotedLearners = [];
  copyLearners: any;
  temp: any;
  type: String;
  title: any;
  files: any;
  materialId: any;
  learnerLength: any;
  learner: any;
  assignedLearner: number = 0;
  pendingLearners: number = 0;
  resubmissionLearners: number = 0;
  submittedLearners: number = 0;
  completedLearners: number = 0;
  // allLearners: any;
  unassignedLearners: number = 0;
  reSubmittedLearners: number = 0;
  learnerNames = [];
  displayLearners: Boolean = false;
  displaySubFolders: boolean = false;
  allocatedLearners = [];
  allLearnersCount: any;
  duedate: any;
  // today
  learnerCopy: any;
  indexForMatTab: number = 1;
  allFiles: any;
  currentUser: any;
  user;
  hideActions: boolean;
  currentColor: string;
  link: any;
  callGetLearner: boolean = false;
  sessionType: any;
  courseType: string;
  quizzes: any;
  previousUrl: string;
  noDataMsg: any = {
    title: "No Quiz Found!",
    data: "You have not added any quiz yet."
  }
  selectedCourseUnit: any = []
  quizStausOfLearner = []
  quizLink
  quizColor
  displayQuiz = []
  singleCourse: any;
  currentCourse
  courseId: string;
  isIQA: boolean = false;
  systemDate
  currentDate
  constructor(private changeDetector: ChangeDetectorRef, public _portfolioService: PortfolioService, private _materialService: MaterialService, private _learnerService: LearnerService, public dialog: MatDialog,
    public _snackBar: MatSnackBar, public router: Router, public activatedRoute: ActivatedRoute, public _filter: FilterService
    , private _sharedService: SharedService, public _quizService: QuizService, public _timeSheetService: TimeSheetService) {
    this.bgColors = ["btn-red", "btn-teal", "btn-blue", "btn-yellow", "btn-pink"];
  }
  ngOnInit() {

    // console.group(" ******** materail tile ngOnInit ******** ", this.activatedRoute.snapshot.paramMap.get('courseId'))
    this.courseId = this.activatedRoute.snapshot.paramMap.get('courseId')
    console.log("check current user=============>", this.user)

    console.log(" MATERIAL ", this.material)
    // console.log(this.activatedRoute.snapshot.paramMap.get('jobid'), " =================================this.router.url ")
    // this._timeSheetService.getSystemDate().subscribe((date) => {
    //   console.log("single date value", date);
    //   this.today = date.systemDate;
    // })
    // if(this.systemDate) this.today = this.systemDate
    this._sharedService.sharedFolder.subscribe(item => {
      if (item.fileId && item.type == 'material') {
        if (this.allFiles) {
          let index = _.findIndex(this.allFiles, function (o) { return o._id == item.fileId })
          if (index > -1) this.allFiles.splice(index, 1)
        }
        else {
          console.log("FILES DOESNOT EXISTS")
        }
      }
    })

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))

    if (this.user.isClient || this.user.isTrainer || this.user.isIQA) this.hideActions = true

    this.activatedRoute.queryParams.subscribe(param => {
      if (param) {
        console.log("QUERY PARAMS ON MATERIAL_TILE", param)
        if (param.courseType == 'Level2') {
          // this.getQuizzes()
          console.log("COURSETYPE VALUE ASSIGNED HERE");
          this.courseType = 'Level2'
          this.changeDetector.detectChanges()
        }

        this.jobId = param['job']

        if (!this.jobId) this.jobId = this.activatedRoute.snapshot.paramMap.get('jobid')



        console.log("this.jobId in queryParams is", this.jobId);
      }
      else {
        this.activatedRoute.snapshot.paramMap.get('jobid')
      }
    })



    if (this.router.url.includes('/jobs')) {
      console.log("first if condition", this.material);

      this.displayLearners = true
      // this.getLearners()
      // this.assignmentStatusWithLearner(this.jobId, "true")
      this.learner = this.learnersFromJob
      this.getCount()
      this.indexForMatTab = 2;
      let id = '#' + this.material._id;
      $(id).addClass('mat-tab-label-active')
    }

    if (this.material != undefined) {
      console.log("second if condition", this.material);

      this.backupMaterial = JSON.parse(JSON.stringify(this.material));

      this.type = (this.material.type ? this.material.type : '')
      console.log('this is type', this.type)
      this.title = this.material.title;
      this.materialId = this.material._id;
    }

    console.log("this.jobId", this.jobId)
    console.groupEnd()
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("*****Changes in materials tile", changes);
    if (changes.today && changes.today.currentValue) {
      console.log("date in material-tile...", changes.today.currentValue);
      this.currentDate = changes.today.currentValue.date
    }
    if (changes.Iqa && changes.Iqa.currentValue === true) {
      console.log("changes...", changes.Iqa);
      this.isIQA = true;
    }
    if (changes.folder != undefined) {
      if (changes.folder.currentValue != undefined) {
        this.type = 'folder';
        this.title = this.folder.title;
        this.files = this.folder.files;
        this.copyFiles = this.folder.files;
        this.displaySubFolders = true;
      }
    }
    if (this.displayLearners == true) {
      if (changes.jobId != undefined) {
        if (changes.jobId.currentValue != undefined) {
          this.learner = changes.learnersFromJob.currentValue
          console.log("this.learner in changes.jobId", this.learner);
          this.getCount()
        }
      }
    }

    if (changes.material && changes.material.currentValue) {
      if (changes.material && changes.material.currentValue) {
        this.materialId = changes.material.currentValue.material_id;
        console.log('HELLLLLLLLLLLLLLLLLLLL', changes.material.currentValue)
        if (changes.material && changes.material.currentValue.portfolioId) {
          console.log("IN IF")
          this.type = 'session'
          this.sessionType = changes.material.currentValue.sessionType
          this.changeDetector.detectChanges()
          console.log("IN IF THIS.TYPE", this.type)
          this.material = changes.material.currentValue
          // this.materialId = changes.material.currentValue._id
        }
        else {
          this.assignedLearner = 0
          this.pendingLearners = 0
          this.resubmissionLearners = 0
          this.submittedLearners = 0
          this.completedLearners = 0
          this.reSubmittedLearners = 0;
        }

        this.allFiles = changes.material.currentValue.files
      }
    }
    if (changes.learnersAlloted && changes.learnersAlloted.currentValue == true) {
      console.log("changes.learnersAlloted", changes.learnersAlloted)
      this.assignmentStatusWithLearner(this.jobId, "true")
      // this.isSelected = false;
    }
    if (changes.learnersFromJob && changes.learnersFromJob.currentValue) {
      this.learner = changes.learnersFromJob.currentValue
      console.log("***in changes.learnersFromJob", this.learner);
      this.getCount()
    }
    if (changes.allLearners && changes.allLearners.currentValue) {
      this.allLearners = changes.allLearners.currentValue;
      this.allLearnersCount = changes.allLearners.currentValue.length || 0
      console.log("this.allLearners in material tile.........", this.allLearners);
      this.learnerCopy = this.allLearners;
    }
    if (changes.showLearnerTab && changes.showLearnerTab.currentValue) {
      this.displayLearners = changes.showLearnerTab.currentValue
    }
    // console.log("changes in mat tile------>>>>>>");
    if (changes.learnerWithStatus && changes.learnerWithStatus.currentValue) {
      console.log("1111111111111changes.statusOfLearner", changes.learnerWithStatus.currentValue);
      this.learner = changes.learnerWithStatus.currentValue

    }
    if (changes.allocated) {
      // this.getLearners()
    }


    if (changes.unitSelected && changes.unitSelected.currentValue) {
      console.log("what is the selected unit data with title===========", changes.unitSelected.currentValue);
      this.selectedCourseUnit = changes.unitSelected.currentValue
    }

    if (changes.jobData && changes.jobData.currentValue) {
      this.singleJobData = changes.jobData.currentValue
    }

    if (changes.learnerQuizStatus && changes.learnerQuizStatus.currentValue) {
      this.quizStausOfLearner = changes.learnerQuizStatus.currentValue
      console.log("all learner quiz status", this.quizStausOfLearner, this.materialId);

    }

    if (changes.courseSelected && changes.courseSelected.currentValue) {
      this.currentCourse = changes.courseSelected.currentValue
      console.log("single course data", this.currentCourse);

    }

    if (changes.userRole && changes.userRole.currentValue) {
      this.userRole = changes.userRole.currentValue
      console.log("userRole ------>  ", this.userRole);
    }
  }

  getRandomColorClass() {
    // let i = Math.floor(Math.random() * this.bgColors.length);
    let rand = Math.floor(Math.random() * this.bgColors.length);
    rand = this.i % 5;
    this.lastColor = rand;
    // console.log("RETURNING", this.bgColors[rand]);

    return this.bgColors[rand];
  }

  async getMaterialFiles() {
    console.log(" this.material ===================+++> ", this.material);
    console.log("INDEX IS addind border", this.i);
    console.log("material id selected", this.materialId);

    let tempId = "#" + this.materialId
    $(tempId).addClass('box_shadow_cls selectedBorder')
    console.log(" Yash ", tempId)
    // this.temp = this.copyLearners;
    // console.log("Getting Material ID from materialTile component", this.temp);
    if (this.material != undefined) {
      console.log("call this with out material");

      this.getFiles.emit({
        materialId: this.material._id,
      });
      if (this.learner != undefined) {
        this.getCount()
        console.log("***in getMaterialFiles()  getLearnerCheck() CALLED ", this.allLearners)
        console.log("this.allLearner @268 before calling getLEarnerCheck() ==>", this.allLearners);
        // await this.assignmentStatusWithLearner();
        this.getLearnerCheck()
      }
    }
    if (this.folder != undefined) {
      // console.log("folder open");
      this.fileDetails(this.folder);
    }
  }
  removeBorder() {
    console.log("INDEX IS removing border", this.i);
    console.log("if material is selected", this.materialId);

    let tempId = "#" + this.materialId
    $(tempId).removeClass('box_shadow_cls selectedBorder')
    // $('#'+this.i).removeClass('selectedBorder')
  }

  addQuizModal() {
    this.activatedRoute.params.subscribe(param => {
      console.log("PARAMS IN MATERIAL TILE", param)
      this.jobId = param.jobid
    })
    let obj = {
      // sessionType: this.sessionType,
      materialId: this.materialId,
      isEdit: false
    }
    this.openDialog(AddQuizModalComponent, obj).subscribe(res => {
      console.log('RES', res)
      if (!res) return
      else {
        this.router.navigate(['/create-quiz'], { queryParams: { quizId: res._id, jobId: this.jobId } })
      }
    })
  }


  singelQuiz(quizId) {
    this.router.navigate(['/quiz/create-quiz'], { queryParams: { quizId: quizId, jobId: this.jobId } })
  }


  fileDetails(event) {
    event.materialIndex = this.i
    console.log("this . material object => @material tile @297", event)
    this.fileDetailsComp.emit(event)
    // console.log("event in material-tile", event);
  }
  closeFileDetails() {
    console.log("Expansion closed^");

    let tempId = "#" + this.materialId
    $(tempId).removeClass('box_shadow_cls selectedBorder')
    console.log(" Yash ", tempId)
  }
  applyFilter(filterValue: string) {
    // console.log("filterValue", filterValue);

    this.files = this._filter.filter(filterValue, this.copyFiles, ['title', 'type']);
  }
  copyFiles(filterValue: string, copyFiles: any, arg2: string[]): any {
    throw new Error("Method not implemented.");
  }
  openDialog(someComponent, data = {}): Observable<any> {
    // console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, disableClose: true });
    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  editmaterial() {
    // console.log("", this.type)
    if (this.type != 'session') {
      console.log("what is single material details", this.material);
      this.material['courseFolder'] = this.selectedCourseUnit[0]._id

      this.openDialog(AddMaterialModalComponent, { material: this.material }).subscribe(materialEdit => {
        if (materialEdit == undefined) return
        console.log("MATERIAL", materialEdit);
        this.title = materialEdit.title;
        let newmaterialEdit;
        // this.getQuizzes()

        newmaterialEdit.quizId = materialEdit.quiz;
        console.log("material edited is", materialEdit)
        this.material.quizId = materialEdit.quiz;
        this.material = materialEdit;
        console.log("*** editMaterial this.getLearnerCheck() called", this.jobId)
        if (this.jobId) {
          this.assignmentStatusWithLearner(this.jobId, 'true')
        }
        this.EditMaterial.emit(materialEdit);
      })
    }
    else {
      let data = {
        session: true,
        course: this.course,
        data: this.material,
        isEdit: true
      }
      this.openDialog(AddSessionModalComponent, data).subscribe(materialEdit => {
        if (materialEdit == undefined) return
        console.log("MATERIAL", materialEdit);
        this.title = materialEdit.title;
        console.log("material edited is", materialEdit)
        this.material = materialEdit;
        console.log("*** editMaterial this.getLearnerCheck() called")
        if (this.jobId) {
          this.assignmentStatusWithLearner(this.jobId, 'true')
        }
        this.EditMaterial.emit(materialEdit);
      })
    }

  }


  deleteMaterial() {
    this.openDialog(DeleteConfirmModalComponent, "Material").subscribe(confirm => {
      // if(confirm != undefined) return
      if (confirm == 'yes') {
        console.log("CONFIRM", confirm, this.material._id);
        // this.loading = true;
        if (this.type != 'session') {
          this._materialService.deleteMaterial(this.material._id).subscribe(updatedmaterial => {
            console.log("MATERIAL SERVICE");
            this.loading = false;
            this.editing = false;
            console.log("Deleted material. ID = ", this.material._id);
            this.DeleteMaterial.emit(this.material);
          }, err => {
            console.error(err);
            this.loading = false;
            this.openSnackBar("Material couldn't be updated. Please try again later.", "OK")
            this.material = this.backupMaterial;
            this.editing = false;
          })
        }
        else {
          this._portfolioService.deleteSession(this.materialId, this.material.sessionType).subscribe(res => {
            console.log("SESSION SERVICE");
            this.loading = false;
            this.editing = false;
            console.log("Deleted session. ID = ", this.material._id);
            this.DeleteMaterial.emit(res);
          }, err => {
            console.error(err);
            this.loading = false;
            this.openSnackBar("Session couldn't be updated. Please try again later.", "OK")
            this.material = this.backupMaterial;
            this.editing = false;
          })
        }
      }
      else return
    })

  }

  UpateData(courses: any) {
    // throw new Error("Method not implemented.");
  }

  createFolder() {
    let currentFolder = this.folder;
    // console.log("currentFolder", this.folder);
    this.openDialog(CreateFolderModalComponent, this.folder).subscribe(folder => {
      if (folder == undefined) return
    }, error => {
      // console.log("ERROE$$$");

    })
  }
  subFolder() {
    // console.log("SUB FOLDER CLICKED");
  }
  // GET LEARNER COUNT
  getCount() {
    console.log("in get counts", this.learner);

    this.learnerNames = [];
    this.assignedLearner = 0
    this.pendingLearners = 0
    this.resubmissionLearners = 0
    this.submittedLearners = 0
    this.completedLearners = 0
    this.reSubmittedLearners = 0;
    this.unassignedLearners = 0;
    if (this.learner) {
      this.learner.forEach(singleLearner => {
        singleLearner.assignments.forEach(assignment => {
          if (assignment.assignmentId == this.materialId) {
            this.learnerNames.push(singleLearner.learnerName)
            this.assignedLearner += 1;
            if (assignment.assignmentStatus == 'Pending') {
              this.pendingLearners += 1
            }
            else if (assignment.assignmentStatus == 'Requested for Resubmission') {
              this.resubmissionLearners += 1
            }
            else if (assignment.assignmentStatus == 'Submitted') {
              this.submittedLearners += 1
            }
            else if (assignment.assignmentStatus == 'Completed') {
              this.completedLearners += 1
            }
            else if (assignment.assignmentStatus == 'Re-submitted') {
              this.reSubmittedLearners += 1
            }
            else if (assignment.assignmentStatus == 'Unassigned') {
              this.unassignedLearners += 1
            }
          }
          // this.unassignedLearners = (this.allLearnersCount - this.assignedLearner > 0) ? this.allLearnersCount - this.assignedLearner : 0;
        })
      })
    }
  }



  onSelectChange(event, i) {
    // console.log("EVENT CHANGE", event)

    if (event.checked == true) {
      this.allocatedLearners.push(event.source.value)
    }
    if (event.checked == false) {
      this.allocatedLearners.forEach((learner) => {
        if (learner._id == event.source.value._id) {
          this.allocatedLearners.splice(learner, 1)
        }
      })
    }
    // console.log("allocated learners", this.allocatedLearners);
  }
  allocateMaterial(jobId) {
    console.log(" Yash Check the jobId ", this.jobId)
    let newMaterial;
    this.loading = true;
    this.assignmentAllocated.emit({ msg: 'assignment allocated from material tile' })
    this.allocatedLearners.forEach(learner => {
      this.allLearners.forEach(singleLearner => {
        if (learner._id == singleLearner._id) {
          singleLearner.checked = true
        }
      })
    })
    let learners = [];
    if (this.allocatedLearners) {
      if (this.duedate == undefined) this.duedate = moment(this.today).format('MM/DD/YYYY')
      if (this.material) {
        newMaterial = {
          _id: this.material._id,
          title: this.material.title,
          unitNo: this.material.courseUnit[0].unitNo,
          assignmentNo: this.material.assignmentNo,
        }
      }
      this.allocatedLearners.forEach((learner) => {
        let newLearner = {
          _id: learner._id,
          name: learner.name,
          email: learner.email,
          duedate: this.duedate
        }
        learners.push({ learner: newLearner, assignments: [newMaterial], job: this.jobId });
      });
    }
    // console.log("learners in allotment", jobId)
    // console.log("learners in allotment", this.jobId)
    console.log("learners in allotment", learners)

    this._learnerService.allocateLearner(learners).subscribe(data => {
      this.loading = false;
      console.log("data after allcation successfully =====>", data);
      this.openSnackBar("Learners allocated successfully!", "OK")
      console.log("this.jobId after allocation", this.jobId);
      this.assignmentStatusWithLearner({ _id: this.jobId }, "true")
    }, err => {
      this.openSnackBar("Something Went Wrong!", "OK")
    });
    this.getCount()
    this.getLearners()
    this.openSnackBar("Learners allocated successfully!", "OK")
  }


  dueDate(event, control) {
    console.log("Event-------->", event, control)
    if (control == 'today')
      this.duedate = event

  }


  getLearnerCheck() {

    console.group(" ****** getLearnerCheck ****** ")

    console.log(' getLearnerCheck this.allLearners ', this.allLearners);
    console.log(' getLearnerCheck this.learners ', this.learner);

    if (this.allLearners) {
      this.allLearners.forEach(singleLearner => {

        // console.log("this.material._id", this.material._id)
        let temp = JSON.parse(JSON.stringify(this.material._id)) || null

        if (temp) {
          console.log("getLearnerCheck If temp ", temp)

          let index1 = _.findIndex(singleLearner.allotments, function (o) {
            if (o.assignment && o.assignment._id) {
              // console.log("o.assignment._id", o.assignment._id)
              // console.log("this.material._id", temp)
              return o.assignment._id == temp;
            }
          });

          if (index1 > -1) {
            let element = _.find(this.learner, function (o) { return o.learnerId == singleLearner._id; })
            console.log("what is in this element", element);
            // if (element && element.length)
            let assignment = _.find(element.assignments, function (o) { return o.assignmentId == temp; })
            console.log("this is assignment", assignment);
            if (assignment && assignment.assignmentStatus != 'Unassigned') {
              singleLearner.checked = true
            } else {
              singleLearner.checked = false
            }
          } else {
            singleLearner.checked = false
          }
        }
        else {
          console.log(" getLearnerCheck  ELSE IN temp Learner ")
        }
      })

      console.log(" getLearnerCheck Finally All learnes are displayed ", this.allLearners)
      console.groupEnd()

    }
    this.getCount()
  }

  filter(filterValue: string) {
    this.allLearners = this._filter.filter(filterValue, this.learnerCopy, ['name']);
  }
  getToolTipData(learner, i) {
    let tempLearner = this.allLearners[i]
    let materialId = this.materialId
    if (this.allLearners && this.learner) {
      let index = _.findIndex(this.learner, function (o) { return o.learnerId == tempLearner._id })
      // console.log("index", index);

      if (index > -1) {
        let index2 = _.findIndex(this.learner[index].assignments, function (o) { return o.assignmentId == materialId })
        // console.log("index ===========2", index2);

        if (index2 > -1) {
          if (this.learner[index].assignments[index2] && this.learner[index].assignments[index2].allotmentId) {
            this.link = '/learnerAllotment/' + this.learner[index].assignments[index2].allotmentId
            this.tempParmas = false
          } else {
            this.link = '/user/' + tempLearner._id
            this.tempParmas = true

          }
          if (this.learner[index].assignments[index2].assignmentStatus == 'Pending') this.currentColor = '#d11919'
          else if (this.learner[index].assignments[index2].assignmentStatus == 'Requested for Resubmission') this.currentColor = '#ffb03b'
          else if (this.learner[index].assignments[index2].assignmentStatus == 'Submitted') this.currentColor = '#448aff'
          else if (this.learner[index].assignments[index2].assignmentStatus == 'Completed') this.currentColor = '#64fe00'
          else if (this.learner[index].assignments[index2].assignmentStatus == 'Re-submitted') this.currentColor = '#f2f2f2'
          else if (this.learner[index].assignments[index2].assignmentStatus == 'Unassigned') this.currentColor = '#ffeb3b'
          return this.learner[index].assignments[index2].assignmentStatus
        }
        else {
          this.link = '/user/' + tempLearner._id
          this.currentColor = '#ffeb3b'
          this.tempParmas = true
          return 'Unassigned'
        }
      }
      // return this.learner[index].assignments[0].assignmentStatus
    }
    else {
      this.link = '/user/' + tempLearner._id
      this.tempParmas = true
      this.currentColor = '#ffeb3b'
      return 'Unassigned'
    }
  }


  redirection() {
    console.log("this link data", this.link);
    let temp = this.link.includes('user')
    console.log("single temp data", temp);
    if (temp) this.router.navigate([this.link], { queryParams: { job: this.jobId } });
    else this.router.navigate([this.link])
  }

  getQuizTooltipData(learner, index) {
    let tempLearner = this.allLearners[index]
    let materialId = this.materialId
    // console.log("this is temp learner data", tempLearner);
    // console.log("this.quizStausOfLearner this.quizStausOfLearner", this.quizStausOfLearner);

    if (this.allLearners && this.quizStausOfLearner) {
      let index = _.findIndex(this.quizStausOfLearner, function (o) { return o.learnerId == tempLearner._id })

      if (index > -1) {
        let index2 = _.findIndex(this.quizStausOfLearner[index].assignments, function (o) { return o.assignmentId == materialId })

        if (index2 > -1) {
          if (this.quizStausOfLearner[index].assignments[index2] && this.quizStausOfLearner[index].assignments[index2].allotmentId) {
            this.quizLink = '/learnerAllotment/' + this.quizStausOfLearner[index].assignments[index2].allotmentId
          } else {
            this.quizLink = '/user/' + tempLearner._id
          }

          // this.changeDetector.detectChanges()
          this.displayQuiz = this.quizStausOfLearner[index].assignments[index2].quiz
          // console.log("display quiz data", this.displayQuiz);
          return this.displayQuiz.length
        }
        else {
          this.quizLink = '/user/' + tempLearner._id
          this.quizColor = '#d11919'
          return 'Pending'
        }
      }
      // return this.learner[index].assignments[0].assignmentStatus
    }
    else {
      this.quizLink = '/user/' + tempLearner._id
      this.quizColor = '#d11919'
      return 'Pending'
    }
  }

  redirectFunction() {
    if (this.tempParmas) {
      this.router.navigate([this.link], { queryParams: { job: this.jobId } })
    } else {
      this.router.navigate([this.link])
    }

  }

  getQuiLink(index) {
    let tempLearner = this.allLearners[index]
    let materialId = this.materialId
    console.log("learner in getToolTipData", tempLearner)
    // return i
    if (this.allLearners && this.quizStausOfLearner) {
      let index = _.findIndex(this.quizStausOfLearner, function (o) { return o.learnerId == tempLearner._id })
      // console.log("index", index);
      if (index > -1) {
        let index2 = _.findIndex(this.quizStausOfLearner[index].assignments, function (o) { return o.assignmentId == materialId })
        // console.log("index ===========2", index2);
        if (index2 > -1) {
          if (this.quizStausOfLearner[index].assignments[index2] && this.quizStausOfLearner[index].assignments[index2].allotmentId) {
            return this.quizLink = '/learnerAllotment/' + this.quizStausOfLearner[index].assignments[index2].allotmentId
          }
        }
      }
    }
  }


  /**
   * 
   *  **************************
   * pending status redirect function
   * *********************************************
   */

  getQuiLinkPending(index) {
    console.log("find index here====>", index)
    let tempLearner = this.allLearners[index]
    let materialId = this.materialId
    console.log("learner in getToolTipData", tempLearner)
    // return i
    if (this.allLearners && this.quizStausOfLearner) {
      let index = _.findIndex(this.quizStausOfLearner, function (o) { return o.learnerId == tempLearner._id })
      // console.log("index", index);
      if (index > -1) {
        let index2 = _.findIndex(this.quizStausOfLearner[index].assignments, function (o) { return o.assignmentId == materialId })
        // console.log("index ===========2", index2);
        if (index2 > -1) {
          if (this.quizStausOfLearner[index].assignments[index2] && this.quizStausOfLearner[index].assignments[index2].allotmentId) {
            this.quizLink = '/learnerAllotment/' + this.quizStausOfLearner[index].assignments[index2].allotmentId
            this.router.navigate([this.quizLink])
          } else {
            this.activatedRoute.params.subscribe(param => {
              console.log("PARAMS IN MATERIAL TILE", param)
              this.jobId = param.jobid
            })
            this.router.navigate(['/user/' + tempLearner._id], { queryParams: { job: this.jobId } })

          }
        }
        else {
          // http://localhost:4200/user/5ff6f21c5fe3700510f75283?job=5ff6af29f9a74c09c83f4898
          // this.activatedRoute.params.subscribe(param => {
          //   console.log("PARAMS IN MATERIAL TILE", param)
          //   this.jobId = param.jobid
          // })
          // return this.router.navigate(['/create-quiz'], { queryParams: { learnerId: tempLearner._id, jobId: this.jobId } })

          this.quizLink = '/user/' + tempLearner._id
          this.router.navigate([this.quizLink], { queryParams: { job: this.jobId } })
          // this.quizColor = '#d11919'
          // return 'Pending'
        }
      }
      // return this.learner[index].assignments[0].assignmentStatus
    }
    else {
      this.quizLink = '/user/' + tempLearner._id
      this.router.navigate([this.quizLink], { queryParams: { job: this.jobId } })
      // this.quizColor = '#d11919'
      // return 'Pending'
    }
  }



  redirectToQuiz(quiz) {
    this.activatedRoute.params.subscribe(param => {
      console.log("PARAMS IN MATERIAL TILE", param)
      this.jobId = param.jobid
    })
    this.router.navigate(['/create-quiz'], { queryParams: { quizId: quiz, jobId: this.jobId } })
  }

  // }
  // console.log("THIS.ALLLEARNERS", this.allLearners);

  // API
  getLearners() {
    this.jobId = this.activatedRoute.snapshot.paramMap.get('jobid')
    this._learnerService.getLearnersByJobId(this.jobId).subscribe(allLearners => {
      console.log("**allLearners", allLearners);
      this.allLearnersCount = allLearners.length || 0
      this.allLearners = allLearners
      // this.allLearners.forEach(learner => {
      //   learner.checked = false
      // })
      this.getCount()
      // setTimeout(() => {
      //   this.allLearners.forEach(learner => {
      //     learner.checked = false
      //   })
      // }, 2000);
      // this.getLearnerCheck()
      this.learnerCopy = this.allLearners;
    })
  }

  assignmentStatusWithLearner(jobId, doGetCount) {
    this.jobId = this.activatedRoute.snapshot.paramMap.get('jobid')
    console.log("this.jobId", this.jobId)
    let obj = {
      _id: this.jobId
    }
    console.log("obj", obj)
    this._materialService.assignmentStatusWithLearner(obj).subscribe((data) => {
      console.log("data of all assignments list", data);

      this.learner = JSON.parse(JSON.stringify(data));
      console.log("*****assignmentStatusWithLearner have to display this all", this.learner);
      // if (doGetCount == "true") this.getCount()
      this.getCount()
      this.getLearners()
      // if (this.callGetLearner == true) {
      // }
      // this.getLearnerCheck()
      this.learnerLength = data.length;
    });
  }



  checkTabStatus() {

    if (this.router.url.includes('/jobs')) {

      if (this.currentCourse.courseMetaId.trackerType.includes('file') && this.material.type == 'Assignment') {
        if (this.learner && this.learner.length && this.material.quiz && !this.material.quiz.length) {

          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    else {

      if (this.currentCourse && this.currentCourse.courseMetaId.trackerType.includes('file') && this.material.type == 'Assignment') {
        if (this.learner && this.learner.length && this.material.quiz && !this.material.quiz.length) {

          return true
        } else {
          return false
        }
      } else {
        return false
      }
      // return false
    }
  }



  checkMaterialFiles() {

    if (this.router.url.includes('/jobs')) {

      if (this.currentCourse.courseMetaId.trackerType.includes('file') || this.material.type == 'Reading') {
        // if (this.learner && this.learner.length) {

        if (this.material && this.material.quiz && this.material.quiz.length) {
          return false
        } else {
          return true
        }
        // } else {
        //   return falsefalse
        // }
      } else {
        return false
      }
    }
    else {
      if (this.currentCourse && this.currentCourse.courseMetaId.trackerType.includes('file') || this.material.type == 'Reading') {
        if (this.material && this.material.quiz && this.material.quiz.length) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
      // return false
    }
  }

  checkQuizTabStatus() {
    if (this.router.url.includes('/jobs')) {
      if (this.currentCourse.courseMetaId.trackerType.includes('quiz') && this.material.type == 'Assignment') {
        if (this.allLearners && this.allLearners.length && this.material.quiz && this.material.quiz.length) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      if (this.currentCourse.courseMetaId.trackerType.includes('quiz') && this.material.type == 'Assignment') {
        if (this.allLearners && this.allLearners.length && this.material.quiz && this.material.quiz.length) {
          return true
        } else {
          return false
        }
      } else {
        return false
        // return false
      }
    }
  }


  // getQuizzes(){
  //   this._quizService.getQuizzes(this.material._id, this.material.sessionType).subscribe(res=>{
  //     console.log("in material tile getting quizzez", res)
  //     this.material.quizId = res
  //   })
  // }


}
